import axios from 'axios'
import { getToken } from './auth'

const api = axios.create({
  baseURL: 'https://muralsisuservice.evolucional.com.br',
})

api.interceptors.request.use(async (config) => {
  const token = getToken()

  if (token)
    config.headers.Authorization = `Bearer ${token}`

  return config
})

// api.interceptors.response.use(
//   function (response) {
//     return response
//   },
//   function (error) {
//     if (error.response.status === 401) {
//       logout()
//       window.location.href = '/login'
//       return
//     }

//     return Promise.reject(error)
//   }
// )

export default api
